import { LayoutFlowConstants } from "../../../components/specific/Onboarding/templates/constants";

export const getPageById = (state, pageId) => {
  return state.layoutFlow.pages.find(page => page.id === pageId);
};

export const getComponentByPageAndId = (state, pageId, componentId) => {
  const page = getPageById(state, pageId);
  if (!page) return null;
  return page.components.find(component => component.id === componentId);
};

export const getTestimonialByIdOrTempId = (state, testimonialId) => {
  return state.testimonials.find(testimonial =>
    testimonial.id === testimonialId || testimonial.tempId === testimonialId
  );
};

export const getTestimonialComponentId = (testimonialComponent) =>
  testimonialComponent.id || testimonialComponent.tempId;

export const getComponentForTestimonial = (state, pageId, testimonialId) => {
  const pageToUpdate = getPageById(state, pageId);

  if (pageToUpdate) {
    return pageToUpdate.components.find(component =>
      (component.refObjectId === testimonialId ||
        (component.refObjectTempId && component.refObjectTempId === testimonialId)) &&
        component.refObjectType === LayoutFlowConstants.RefObjectType.TESTIMONIAL
    );
  }
};

export const getKeyForTestimonialValidation = (testimonialId, fieldKey) =>
  `testimonial_${testimonialId}_${fieldKey}`;

export const removeValidationErrorForTestimonial = (state, testimonialId, fieldKey) => {
  if (!fieldKey) {
    Object.keys(state.validationErrors).forEach((key) => {
      if (key.startsWith(`testimonial_${testimonialId}_`)) {
        delete state.validationErrors[key];
      }
    });
  } else {
    const testimonialKey = getKeyForTestimonialValidation(testimonialId, fieldKey);
    if (testimonialKey) {
      delete state.validationErrors[testimonialKey];
    }
  }
};
